<template>
  <div v-reportView:login="{ step: 1, usertype: '', ext: 1 }" class="login_dialog_box">
    <div class="dialog_box">
      <div class="close_box"><IconClose @click.native="clickClose" /></div>
      <div class="dialog_logo" />
      <FontLine>请先登录，QQ和微信是独立账号，信息不互通</FontLine>
      <ul class="login_box">
        <li class="login_item" @click="login(loginType.wechat)" />
        <li class="login_item" @click="login(loginType.qq)" />
      </ul>
      <div class="user_agreement_box">
        <Checkbox :status="true" @select="select" />
        <p class="font">我已阅读并接受<a class="agreement" @click="userProtocol">用户协议</a></p>
      </div>
    </div>
    <DialogC v-model="loginQrDialog" size="max" :title="'完美办公'">
      <QrDialog :type="selectType" :url="loginUrl" />
    </DialogC>
  </div>
</template>

<script>
import IconClose from '@/components/Icons/IconClose.vue'
import FontLine from '@/components/FontLine/index.vue'
import Checkbox from '@/components/Checkbox/index.vue'
import QrDialog from '@/views/common/QrDialog/index.vue'
import DialogC from '@/components/DialogC/index.vue'

import { loginType, postMessageType, queryLoginType } from '@/common/const.js'
import { proxyUrl, userProtocol } from '@/common/resources.js'
import { ClientOpenWebsiteUrl, ClientSetUserInfo } from '@/common/clientFunc.js'
import { reportServerId } from '@/common/business.js'
import { CacheSetUserInfo, getSource } from '@/common/cache.js'
import { report } from '@/report/index.js'

import api from '@/api'
import { RetCode, freeVipState } from '@/api/bussinessCode.js'

import WeChatAuth from '@/plugins/auth/wechatAuth.js'
import QQAuth from '@/plugins/auth/qqAuth.js'

export default {
  name: 'LoginDialog',

  components: { IconClose, FontLine, Checkbox, DialogC, QrDialog },

  data () {
    return {
      loginType: Object.freeze(loginType),
      isUseProtocol: true,
      selectType: '',
      loginUrl: '',
      loginQrDialog: false,
      wechatClass: new WeChatAuth(),
      qqClass: new QQAuth()
    }
  },

  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },

    isVip () {
      return this.$store.getters.isVip
    },

    freeVipState () { // 领取会员信息弹框状态
      return freeVipState
    },
  },

  created () {
    this.listenMessage()
  },

  destroyed () {
    window.removeEventListener('message', this.listenFunc)
  },

  methods: {
    reportLogin (step, type = '') {
      report('login', { step, usertype: type, ext: 1 })
    },

    clickClose () {
      this.$store.commit('changeLoginDialogVisible', false)
    },

    select (flag) {
      this.isUseProtocol = flag
    },

    userProtocol () {
      ClientOpenWebsiteUrl(userProtocol)
    },

    login (type) {
      if (!this.isUseProtocol) {
        this.$toast({ desc: '请先阅读用户协议，并勾选' })
        return
      }

      this.selectType = type

      if (type === loginType.wechat) {
        this.reportLogin(2)
        this.loginUrl = this.wechatClass.openAuthPage()
      } else if (type === loginType.qq) {
        this.reportLogin(3)
        this.loginUrl = this.qqClass.openAuthPage()
      }
      this.loginQrDialog = true
    },

    listenMessage () {
      window.addEventListener('message', this.listenFunc)
    },

    listenFunc (data) {
      if (data.data && typeof data.data === 'string') {
        const newData = JSON.parse(data.data)
        const search = newData.search

        if (!search) { return }

        this.reportLogin(4)

        const searchState = search.state
        const qqState = this.qqClass.getState()
        const wechatState = this.wechatClass.getState()

        if (!searchState || !(searchState === qqState || searchState === wechatState)) { return }

        this.reportLogin(5)

        if (!search.code) { return }
        this.userLogin(search.code, search[queryLoginType]) // LoginType第三方接口传过去的参数
      }
    },

    userLogin (code, type) {
      const params = { login_type: 1, code, channel: getSource() }

      // qq登录参数，默认微信登录
      const qqLogin = type === postMessageType.qq
      if (qqLogin) {
        params.qq_redirect_url = encodeURIComponent(proxyUrl)
        params.login_type = 2
      }

      api.user.login({ data: params }).then(res => {
        const data = res.data

        const userType = data?.user_info?.is_new_user === 0 ? 2 : 1 // 默认是新注册

        this.reportLogin(type === postMessageType.qq ? 7 : 6, userType)

        // 存储userInfo，下一步上报需要
        const userInfo = { token: data.token, ...data.user_info }
        this.$store.commit('setUserInfo', userInfo)
        CacheSetUserInfo(userInfo)

        // 为新注册用户，需要上报serverId
        // 需要保证在CacheSetUserInfo后面上报，因为需要传token值需要从cache获取
        if (userType === 1) {
          reportServerId()
        }

        ClientSetUserInfo(userInfo)
        this.getPrivliege(type, userType) // 获取用户权益
      }).catch(() => {
        this.$toast({ desc: '登录异常，请联系客服或刷新重试' })
        this.$store.commit('changeLoginDialogVisible', false)
      })
    },

    getPrivliege (type, userType) {
      let privliegeName = ''
      let privliegeEndTime = ''
      let isVip = false

      api.user.privliege({ data: { common: { token: this.userInfo.token, uid: this.userInfo.uid } } }).then(pRes => {
        privliegeName = pRes.data.name
        privliegeEndTime = pRes.data.end_date
        isVip = true
      }).catch(data => {
        if (data?.ret && data.ret.toString() in RetCode) {
          privliegeName = RetCode[data.ret]
        }
      }).finally(() => {
        const lastUserInfo = { privliegeName, privliegeEndTime, isVip, ...this.userInfo }

        this.reportLogin(type === postMessageType.qq ? 9 : 8, userType)

        this.$store.commit('setUserInfo', lastUserInfo)
        CacheSetUserInfo(lastUserInfo)
        ClientSetUserInfo(lastUserInfo)
        this.$store.commit('changeLoginDialogVisible', false)
        this.loginQrDialog = false

        this.$store.dispatch('getUserCollectIdList') // 获取用户收藏所有id列表

        this.$store.dispatch('initBuyBtn') // 登录后终身会员隐藏成为会员按钮
        this.showVipActivityDialog() // 登录后判断三日会员与终身活动弹窗
      })
    },

    showVipActivityDialog () { // 活动流程
      const freevipMessage = this.$store.state.tipsDialog.freevipMessage
      if (freevipMessage.freevipMessageState === 1) { // 判断登录前是否点击领取会员
        this.initFreePackage()
        return
      }
      this.getActivityWindow()
    },

    getActivityWindow () { // 终身会员弹窗展示
      const userDate = this.$store.getters.initUserDate
      const needShow = this.$store.state.activityNeedShow
      this.$store.commit('changeActivityNeedShow', false) // 还原点击终身活动红包或弹窗状态
      if (userDate > this.$store.getters.lifeTime && needShow) { // 非终身会员走终身vip活动流程
        this.$store.commit('tipsDialog/changeVipActivityMsgVisible', true) // 展示终身会员活动消息框
        return
      }
      this.showDialog() // 弹出支付框
    },

    showDialog () {
      const activityClickType = this.$store.state.activityClickType
      api.common.config({ data: { conf_code: activityClickType } }).then(res => { // 查询点击触发支付框类型
        const config = res?.data?.data?.content
        if (Number(config)) { // 活动支付
          this.$store.dispatch('getActivityWindow') // 查询是否弹出活动支付弹窗
          return
        }
        this.$store.commit('changeBuyDialogVisible', true) // 普通支付框
      }).catch(() => {
        this.$store.dispatch('getActivityWindow') // 未指定弹出类型则直接弹活动框
      })
    },

    initFreePackage () {
      api.member.packages({ data: { chan: 'act-3d' } }).then(res => {
        const packages = res?.data?.pri_packages
        if (packages) {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          this.$store.commit('tipsDialog/changeFreevipMessage', { freeVipPackage: packages[0] }) // 设置套餐
          this.getFreePackage()
        }
      })
    },

    getFreePackage () { // 领取vip
      const source = getSource()
      const freevipMessage = this.$store.state.tipsDialog.freevipMessage
      this.freeVipDialogVisible = false
      api.activity.getFreeVip({ data: { pri_id: freevipMessage.freeVipPackage.id, source: source } }).then(res => {
        const respCommon = res?.data?.resp_common
        if (!respCommon.ret) {
          this.getFreeVipSuccess()
          this.$store.commit('tipsDialog/changeFreevipMessage', { freevipMessageDialog: true, freevipMessageState: freeVipState.suc })
        }
      }).catch((res) => {
        this.$store.commit('tipsDialog/changeFreevipMessage', { freevipMessageDialog: true, freevipMessageState: res.ret })
      })
    },

    getFreeVipSuccess () { // 领取成功设置会员
      api.user.privliege().then(res => {
        const data = res.data
        if (!data.name || !data.end_date) {
          this.$toast({ desc: '领取成功，请刷新页面' })
        }
        const lastUserInfo = { ...this.userInfo, isVip: true, privliegeName: data.name, privliegeEndTime: data.end_date }
        this.$store.commit('setUserInfo', lastUserInfo)
        CacheSetUserInfo(lastUserInfo)
        ClientSetUserInfo(lastUserInfo)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.login_dialog_box { position: fixed; top: 0; z-index: 99; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.4);
  .dialog_box { position: absolute; top: 50%; left: 50%; width: 434px; height: 454px; margin: -227px 0 0 -217px; background-color: #fff; border-radius: 8px; }
  .close_box { padding: 14px 14px 18px 14px; font-size: 0; text-align: right; }

  .dialog_logo { height: 90px; margin-bottom: 40px; background-image: url(~@/assets/images/logo.png); background-repeat: no-repeat; background-position: center center; background-size: 230px 40px; }

  .login_box { padding: 44px 80px 46px 80px; font-size: 0; }
  .login_item { display: inline-block; width: 110px; height: 110px; cursor: pointer;
    &:nth-child(1) { margin-right: 54px; background-image: url(~@/assets/images/icon_dialog_wechat.png); background-size: cover;
      &:hover { background-image: url(~@/assets/images/icon_dialog_wechat_hover.png); }
    }
    &:nth-child(2) { background-image: url(~@/assets/images/icon_dialog_qq.png); background-size: cover;
      &:hover { background-image: url(~@/assets/images/icon_dialog_qq_hover.png); }
    }
  }

  .user_agreement_box { text-align: center;
   .font { display: inline-block; font-size: 12px; font-weight: 400; color: #666; }
   .agreement { color: $primary_color; text-decoration: none; cursor: pointer; }
  }
}
</style>
